<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          Lock Budget Configuration
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9> </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon @click="getData">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <v-row class="px-5">
              <v-flex xs3 class="pt-2">
                <span class="subtitle-1 font-weight-black lightblack--text"
                  >Start Period</span
                >
              </v-flex>
              <v-col cols="auto" class="text-right pr-5">
                :
              </v-col>
              <v-flex xs6>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="start_date"
                      single-line
                      prepend-icon="event"
                      class="pt-0 mt-0"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="start_date"
                    no-title
                    scrollable
                    :min="minDate"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu.save(start_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </v-row>
          </v-flex>
          <v-flex xs12>
            <v-row class="px-5">
              <v-flex xs3 class="pt-2">
                <span class="subtitle-1 font-weight-black lightblack--text"
                  >End Period</span
                >
              </v-flex>
              <v-col cols="auto" class="text-right pr-5 pt-3">
                :
              </v-col>
              <v-flex xs6>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="end_date"
                      single-line
                      prepend-icon="event"
                      class="pt-0 mt-0"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="end_date"
                    no-title
                    scrollable
                    :min="minDate"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu2 = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu2.save(end_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
                <span
                  v-if="validationMessage != ''"
                  class="red--text caption"
                  >{{ validationMessage }}</span
                >
              </v-flex>
            </v-row>
          </v-flex>
          <v-flex xs12>
            <v-row class="px-5">
              <v-flex xs3 class="pt-2">
                <span class="subtitle-1 font-weight-black lightblack--text"
                  >Active Budget Period</span
                >
              </v-flex>
              <v-col cols="auto" class="text-right pr-4 pt-2">
                :
              </v-col>
              <v-flex xs6 class="pa-0">
                <v-col cols="12" class="pa-0">
                  <v-radio-group v-model="option" row class="pt-0 pl-1 mt-2">
                    <v-radio
                      label="Single Year"
                      :value="false"
                      class="pt-0"
                    ></v-radio>
                    <v-radio
                      label="Multiple Year"
                      :value="true"
                      class="pt-0"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-row class="px-3">
                  <v-flex xs5>
                    <date-picker
                      v-model="year"
                      type="year"
                      placeholder="Start Year"
                      format="YYYY"
                      class="lock-budget"
                    >
                    </date-picker>
                    <span
                      v-if="validationStartYear != ''"
                      class="red--text caption pl-8"
                      >{{ validationStartYear }}</span
                    >
                  </v-flex>
                  <v-col
                    cols="auto"
                    class="text-right pr-4 pt-1 fs-16 pr-6 pl-2"
                    v-if="option"
                  >
                    &
                  </v-col>
                  <v-flex xs5 v-if="option">
                    <date-picker
                      v-model="year2"
                      type="year"
                      placeholder="End Year"
                      format="YYYY"
                      class="lock-budget"
                      disabled
                    >
                    </date-picker>
                    <div class="fs-10 primary--text pl-2 lh-13 pt-1">
                      Automatically filled in one year from the first year.
                    </div>
                  </v-flex>
                  <v-row class="px-5">
                    <v-flex xs3 class="pt-1"> </v-flex>
                    <span
                      v-if="validationMessageYear != ''"
                      class="red--text caption pl-8"
                      >{{ validationMessageYear }}</span
                    >
                  </v-row>
                </v-row>
              </v-flex>
            </v-row>
          </v-flex>
        </v-card-text>
        <v-card-actions class="text-right">
          <v-spacer></v-spacer>
          <v-flex xs2 class="mb-5 mr-3">
            <v-btn
              id="saveBtn"
              color="blue darken-2"
              class="white--text"
              block
              @click="save()"
              :disabled="isDisable"
            >
              Save
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ACLMixin from '../../../mixins/ACLMixin';
import moment from 'moment';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin],
  data() {
    return {
      option: false,
      year: new Date(),
      year2: new Date(),
      progressDialogLoading: true,
      loading: true,
      items: [],
      minDate: new Date().toISOString().slice(0, 10),
      start_date: '',
      isDisable: false,
      end_date: '',
      isActive: false,
      descending: true,
      sort: '',
      totalItems: 0,
      options: {
        itemsPerPage: 5
      },
      search: '',
      menu: false,
      menu3: false,
      menu4: false,
      validationMessage: '',
      menu2: false,
      active: false,
      breadcrumbs: [
        {
          text: 'Configuration',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Lock Budget',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      page: 1,
      pageCount: 0,
      timeout: null,
      validationMessageYear: '',
      validationStartYear: '',
      validationEndYear: ''
    };
  },
  mounted() {
    this.getData();
    this.dateCheck(this.start_date, this.end_date);
  },
  watch: {
    start_date(value) {
      this.dateCheck(value, this.end_date);
    },
    end_date(value) {
      this.dateCheck(this.start_date, value);
    },
    year(value) {
      if (value === null) {
        this.validationStartYear = 'Start Year is required.';
        this.isDisable = true;
      } else {
        this.isDisable = false;
        this.validationStartYear = '';
        if (this.option) {
          var year = value.getFullYear();
          var month = value.getMonth();
          var day = value.getDate();
          this.year2 = new Date(year + 1, month, day);
        } else {
          this.year2 = value;
        }
      }
    },
    year2(value) {
      if (value === null) {
        this.validationEndYear = 'End Year is required.';
        this.isDisable = true;
      }
    },
    option(val) {
      if (val) {
        var year = this.year.getFullYear();
        var month = this.year.getMonth();
        var day = this.year.getDate();
        this.year2 = new Date(year + 1, month, day);
      } else {
        this.year2 = this.year;
      }
    },
    menu3(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'));
    },
    saveYear(year) {
      this.$refs.menu3.save(year);

      // Reset activePicker to type YEAR
      this.$refs.picker.activePicker = 'YEAR';

      // Close the menu/datepicker
      this.menu3 = false;
    },
    menu4(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker2 = 'YEAR'));
    },
    saveYear2(year) {
      this.$refs.menu4.save(year);

      // Reset activePicker to type YEAR
      this.$refs.picker.activePicker2 = 'YEAR';

      // Close the menu/datepicker
      this.menu4 = false;
    }
  },
  methods: {
    dateCheck(start, end) {
      this.validationMessageYear = '';
      this.isDisable = false;
      const startDate = new Date(start).toISOString().substr(0, 10);
      const endDate = new Date(end).toISOString().substr(0, 10);
      let today = new Date().toISOString().substr(0, 10);
      if (startDate < today) {
        this.validationMessage =
          'You have entered an invalid date. Please check again.';
        this.isDisable = true;
      } else {
        if (startDate > endDate) {
          this.validationMessage = 'Start Date must be earlier than End Date.';
          this.isDisable = true;
        } else {
          this.validationMessage = '';
          this.isDisable = false;
        }
      }
    },
    getData() {
      this.progressDialogLoading = true;
      this.loading = true;
      return this.$store
        .dispatch('configuration/getLockBudget')
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.items = data.data;
            this.start_date = moment(
              this.items.start_date,
              'YYYY-MM-DD HH:mm:ss'
            ).format('YYYY-MM-DD');
            this.end_date = moment(
              this.items.end_date,
              'YYYY-MM-DD HH:mm:ss'
            ).format('YYYY-MM-DD');
            this.year = new Date(this.items.period[0]);
            this.year2 = new Date(this.items.period[1]);
            if (this.items.period[0] === this.items.period[1]) {
              this.option = false;
            } else {
              this.option = true;
            }
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    save() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to update config lock budget?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.progressDialogLoading = true;
          this.loading = true;
          let params = {
            start_date: this.start_date,
            end_date: this.end_date,
            period: [
              moment(this.year).format('YYYY'),
              moment(this.year2).format('YYYY')
            ]
          };
          console.log(params);
          this.$store
            .dispatch('configuration/updateLockBudget', params)
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.getData();
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>
